import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/svg/sm-google.svg'
import _imports_1 from '../assets/svg/sm-facebook.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2164a8ec")

_pushScopeId("data-v-2164a8ec")
const _hoisted_1 = { class: "register-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Create your account", -1)
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = { class: "checkbox-container" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createTextVNode("I've read and agree to "),
  /*#__PURE__*/_createVNode("a", {
    href: "/terms-of-business-customer",
    target: "_blank"
  }, "the terms and conditions")
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Create Account ")
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Connect With Google", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Connect With Facebook", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "Already have an account?", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Sign In")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_grid, { class: "register-sign-in no-pad" }, {
        default: _withId(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center ion-justify-content-center" }, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                sizeMd: "6",
                sizeXs: "12"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode(_component_ion_input, {
                      class: "sign-in-input",
                      type: "email",
                      placeholder: "Your Name*",
                      required: "",
                      modelValue: _ctx.formFields.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formFields.name = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ion_input, {
                      class: "sign-in-input",
                      type: "email",
                      placeholder: "Email*",
                      required: "",
                      modelValue: _ctx.formFields.email,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formFields.email = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_3, [
                      _createVNode(_component_ion_input, {
                        class: "sign-in-input",
                        type: "phone",
                        placeholder: "Phone Number*",
                        required: "",
                        modelValue: _ctx.formFields.phone,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formFields.phone = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ion_input, {
                        class: "sign-in-input",
                        type: "text",
                        onIonFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.calendarFocus($event))),
                        placeholder: "D.O.B. (optional)",
                        modelValue: _ctx.formFields.dob,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formFields.dob = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_ion_input, {
                      class: "sign-in-input",
                      type: "password",
                      placeholder: "Password",
                      modelValue: _ctx.formFields.password,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formFields.password = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_4, [
                      _createVNode(_component_ion_checkbox, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.privacyChecked = !_ctx.privacyChecked)),
                        class: "create-account-checkbox"
                      }),
                      _hoisted_5
                    ]),
                    _createVNode(_component_ion_button, {
                      color: "success",
                      onClick: _ctx.createAccount,
                      disabled: !_ctx.privacyChecked
                    }, {
                      default: _withId(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode(_component_ion_button, {
                      class: "google social-button",
                      fill: "clear",
                      expand: "block",
                      size: "large",
                      onClick: _ctx.loginGoogle
                    }, {
                      default: _withId(() => [
                        _hoisted_7,
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_ion_button, {
                      class: "facebook social-button",
                      expand: "block",
                      size: "large",
                      onClick: _ctx.loginFacebook
                    }, {
                      default: _withId(() => [
                        _hoisted_9,
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _hoisted_11,
                    _createVNode(_component_router_link, { to: "/sign-in" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_button, { color: "secondary" }, {
                          default: _withId(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                class: "full-bg mobile-none",
                sizeMd: "6",
                sizeXs: "0"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})